import { InjectionToken, inject } from '@angular/core';
import { ParamMap } from '@angular/router';
import { DefaultAddTaskService } from './default-add-task.service';
import { UserSimple } from '../../../../models';

export interface IAddTaskService {
  getHeronUsers(paramMap: ParamMap): Promise<UserSimple[]>;
}

export const ADD_TASK_SERVICE = new InjectionToken<IAddTaskService>('ADD_TASK_SERVICE', {
  providedIn: 'root',
  factory: () => inject(DefaultAddTaskService)
});
